import { Grid as BaseGrid, styled } from '@mui/material'
import { Dialog as BaseDialog } from '@chilecompra/react-kit/components'

export const Dialog = styled(BaseDialog)`
  background-color: transparent;
  &:focus-visible {
    outline: 0;
  }
  overflow-y: hidden;
`
export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`
export const LetterBlue = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: inline-block;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  text-align: center;
  width: 100%;
`
export const WrapperPurchaseOrder = styled('div')`
  height: 300px;
  overflow-y: auto;
  margin: auto;
  width: 80%;
`
export const WrapperTextFooter = styled('div')`
  margin: 16px auto 0;
  width: 70%;
`
